import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UIPopover } from '@irohalab/deneb-ui';
import { UserAccount } from '../../entity/UserAccount';
import { Subscription } from 'rxjs';
import { UserAccountService } from '../user-account.service';

import { UserActionPanelComponent } from './user-action-panel/user-action-panel.component';
import { UserAccountType } from '../../entity/UserAccountType';

@Component({
    selector: 'app-user-action',
    imports: [
    RouterLink
],
    templateUrl: './user-action.component.html',
    styleUrl: './user-action.component.less'
})
export class UserActionComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  currentUser!: UserAccount;

  eUserAccountType = UserAccountType;

  @ViewChild('userActionLink') userActionLinkRef!: ElementRef;

  constructor(private userAccountService: UserAccountService,
              private popover: UIPopover) {
  }

  @HostListener('click')
  onClickUserAction(): void {
    const userActionLinkElement = this.userActionLinkRef.nativeElement;
    const popoverRef = this.popover.createPopover(userActionLinkElement, UserActionPanelComponent);
    popoverRef.componentInstance.user = this.currentUser;
    this.subscription.add(
      popoverRef.afterClosed()
        .subscribe((result) => {
      if (result === 'logout') {
        this.logout();
      }
    }));
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }
  ngOnInit(): void {
      this.subscription.add(
        this.userAccountService.user
          .subscribe((user) => {
            // console.log(user);
            this.currentUser = user;
          })
      );
  }

  logout() {
    this.userAccountService.logout();
  }
}
